import React from 'react';
import { Button, Stack } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { STEP_CONFIG } from '../../constants';
import { getNextStep, getStepIndex } from '../../lib';
import { useDealBuilderStepNavigation } from '../../hooks';
import { useValidateAndAdvance } from '../../hooks/useValidateAndAdvance';

export const StepFooterNav = () => {
  const { viewStep, goToPrevStep } = useDealBuilderStepNavigation();
  const validateAndAdvance = useValidateAndAdvance();

  const stepIndex = getStepIndex(viewStep);
  const isFirstStep = stepIndex === 0;
  const isLastStep = stepIndex === STEP_CONFIG.length - 1;
  const nextStepConfig = STEP_CONFIG[getStepIndex(getNextStep(viewStep))];

  return (
    <Stack direction="row" justifyContent="space-between">
      <Button disabled={isFirstStep} startIcon={<ChevronLeft />} onClick={goToPrevStep}>
        Back
      </Button>

      <Button disabled={isLastStep} variant="contained" endIcon={<ChevronRight />} onClick={validateAndAdvance}>
        Continue to {nextStepConfig.label}
      </Button>
    </Stack>
  );
};
